import * as React from 'react'
import Helmet from 'react-helmet'
import styled from 'styled-components'

import CardConsent from '../../../../components/home/CardConsent/CardConsent'

const StyledCardConsent = styled(CardConsent)`
  padding: 1rem;
`

function MainView() {
  return (
    <>
      <Helmet>
        <style>
          {`.adsbygoogle {
        display: none !important;
      }`}
        </style>
      </Helmet>
      <StyledCardConsent />
    </>
  )
}

export default MainView
